import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'duration_of_the_cba_that_covers_the_greatest_num_of_wrkrs_in_th'

export const dataPointDefinition = {
  retracedId: 'duration_of_the_cba_that_covers_the_greatest_num_of_wrkrs_in_th',
  name: 'Duration of the CBA that covers the greatest number of workers in the workplace (provide NUMBER value for duration in months):',
  description:
    'If more than one CBA covers the same (greatest) number of workers, indicate the duration of the CBA with the longest duration first here, and use the next set of questions for the other CBA.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-42',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12360,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
